import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { Avatar } from '../../types/avatar.type';
import { AvatarComponent } from '../avatar/avatar.component';

@Component({
  selector: 'evc-badge-button',
  templateUrl: 'badge-button.component.html',
  styleUrls: ['./badge-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AvatarComponent],
})
export class BadgeButtonComponent {
  public readonly currentText = input('');
  public readonly additionalText = input<string | undefined>('');
  public readonly avatar = input<Avatar>();
}
